import script from "./LeaveReview.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaveReview.vue?vue&type=script&setup=true&lang=js"

import "./LeaveReview.vue?vue&type=style&index=0&id=070d0f0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-070d0f0a"]])

export default __exports__